// (function () {
//     'use strict';

//     angular.module("imApp").factory("ediMenuService", [function () {
//         let service = {};

//         return service;
//     }]);
// })();
